import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { accountRoleSchema, type AccountRole } from '../../api/apiSchemas';
import { ACCOUNT_ROLE_OPTIONS } from '../../lib/accountRoles';
import { Alert, Button, SelectField, TextField } from '../ui';

const profileFormSchema = z.object({
  displayName: z
    .string()
    .trim()
    .min(2, 'Tên hiển thị cần ít nhất 2 ký tự')
    .max(80, 'Tên hiển thị tối đa 80 ký tự'),
  accountRole: accountRoleSchema,
});

export type ProfileFormValues = z.infer<typeof profileFormSchema>;

export interface ProfileFormProps {
  defaultValues: { displayName: string; accountRole: AccountRole };
  onSubmit: (values: ProfileFormValues) => void;
  submitting: boolean;
  errorMessage?: string | null;
  allowRoleEdit?: boolean;
}

export function ProfileForm({
  defaultValues,
  onSubmit,
  submitting,
  errorMessage,
  allowRoleEdit = true,
}: ProfileFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ProfileFormValues>({
    resolver: zodResolver(profileFormSchema),
    defaultValues,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {errorMessage ? (
        <Alert tone="error" live>
          {errorMessage}
        </Alert>
      ) : null}

      <TextField
        label="Tên hiển thị"
        autoComplete="name"
        error={errors.displayName?.message}
        {...register('displayName')}
      />

      <SelectField
        label="Vai trò tài khoản"
        options={ACCOUNT_ROLE_OPTIONS}
        disabled={!allowRoleEdit}
        hint={allowRoleEdit ? undefined : 'Vai trò không thể thay đổi theo chính sách hiện tại.'}
        error={errors.accountRole?.message}
        {...register('accountRole')}
      />

      <Button type="submit" loading={submitting} disabled={submitting}>
        Lưu thay đổi
      </Button>
    </form>
  );
}
